"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var app_1 = require("firebase/app");
var firestore_1 = require("firebase/firestore");
var functions_1 = require("firebase/functions");
var types_1 = require("@swyft/types");
var labels_1 = require("../../models/labels");
var errorHandler_1 = __importDefault(require("../errorHandler"));
var merchant_1 = require("../merchant");
var types_2 = require("./types");
var LabelController = /** @class */ (function () {
    /**
     * Creates instance with provided config to setup Firebase app.
     * @param {FirebaseOptions} config Firebase configuration to initialize app.
     */
    function LabelController(config) {
        var _this = this;
        /**
         * Get a single label
         * NOTE: only works for merchants
         * @param params.id the id of the label
         * @param params.meta the organization details
         * @returns the label object
         */
        this.getOne = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var label, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, labels_1.get)(this.db, __assign({ id: params.id }, params.meta))];
                    case 1:
                        label = _a.sent();
                        return [2 /*return*/, { data: label }];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_1)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.update = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var label, updatedLabel, err_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, (0, labels_1.update)(this.db, __assign(__assign({ id: params.id }, params.meta), { data: params.data, previousData: params.previousData }))];
                    case 1:
                        label = _b.sent();
                        if (!((_a = params.data.destination) === null || _a === void 0 ? void 0 : _a.address)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.functions.updateAndValidateDestinationAddress({
                                labelId: params.id,
                                address: params.data.destination.address,
                                notes: params.data.notes
                            })];
                    case 2:
                        updatedLabel = _b.sent();
                        // send a notification to the DSP carrying this order and CC our ops team on it
                        return [4 /*yield*/, this.functions.notifyOfDestinationChange({
                                dspId: params.data.dspId,
                                merchant: {
                                    id: params.data.merchantId,
                                    name: params.data.businessName
                                },
                                label: {
                                    trackingNumber: params.data.trackingNumber,
                                    notes: params.data.notes
                                },
                                previousDestination: params.data.destination,
                                destination: updatedLabel.data.destination
                            })];
                    case 3:
                        // send a notification to the DSP carrying this order and CC our ops team on it
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/, { data: label }];
                    case 5:
                        err_2 = _b.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_2)];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.generatePrintPdfs = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions.printPdfLabels(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_3 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_3)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // eslint-disable-next-line class-methods-use-this
        this.getCostBreakdownRateCard = function (label, rateCard, includeActuals) {
            var breakdown = [];
            var baseRate = rateCard.services[label.serviceType][label.packageType];
            if (baseRate) {
                breakdown.push({
                    source: types_2.CostBreakdownSource.RATE_CARD_V1,
                    amount: baseRate,
                    type: types_2.CostBreakdownType.BASE_RATE
                });
            }
            if (label.serviceAddOns) {
                for (var _i = 0, _a = Object.entries(rateCard.addOns); _i < _a.length; _i++) {
                    var _b = _a[_i], key = _b[0], value = _b[1];
                    if (label.serviceAddOns.includes(key) && value) {
                        breakdown.push({
                            source: types_2.CostBreakdownSource.RATE_CARD_V1,
                            amount: value,
                            type: types_2.CostBreakdownType.ADDON_FEE,
                            subType: key
                        });
                    }
                }
            }
            if (includeActuals && label.redeliveryAttempts) {
                var redeliveryRate = rateCard.redeliveryRate[label.packageType];
                if (redeliveryRate) {
                    breakdown.push({
                        source: types_2.CostBreakdownSource.RATE_CARD_V1,
                        amount: redeliveryRate * label.redeliveryAttempts,
                        type: types_2.CostBreakdownType.REDELIVERY_FEE,
                        amountModifier: redeliveryRate
                    });
                }
            }
            return breakdown;
        };
        // eslint-disable-next-line class-methods-use-this
        this.getCostBreakdownRateCardV2 = function (label, rateCard, includeActuals) {
            var breakdown = [];
            var baseRate = merchant_1.MerchantController.getMinRateByService(rateCard, label.serviceType, label.dims);
            if (baseRate) {
                breakdown.push({
                    source: types_2.CostBreakdownSource.RATE_CARD_V2,
                    amount: baseRate,
                    type: types_2.CostBreakdownType.BASE_RATE
                });
            }
            if (label.serviceAddOns) {
                if (rateCard.addOns) {
                    for (var _i = 0, _a = Object.entries(rateCard.addOns); _i < _a.length; _i++) {
                        var _b = _a[_i], key = _b[0], value = _b[1];
                        if (label.serviceAddOns.includes(key) && value) {
                            breakdown.push({
                                source: types_2.CostBreakdownSource.RATE_CARD_V2,
                                amount: value,
                                type: types_2.CostBreakdownType.ADDON_FEE,
                                subType: key
                            });
                        }
                    }
                }
            }
            if (includeActuals && label.redeliveryAttempts) {
                var entry = merchant_1.MerchantController.getMinRateEntryByService(rateCard, label.serviceType, label.dims);
                if (entry && entry.redeliveryRate > 0) {
                    breakdown.push({
                        source: types_2.CostBreakdownSource.RATE_CARD_V2,
                        amount: entry.redeliveryRate * label.redeliveryAttempts,
                        type: types_2.CostBreakdownType.REDELIVERY_FEE,
                        amountModifier: entry.redeliveryRate
                    });
                }
            }
            return breakdown;
        };
        /**
         * Get the cost details for a single label. Aggregates the base rate, add-on fees, and additionally, optional variable costs. (e.g. re-delivery fee)
         * @param merchant the merchant the label is under
         * @param label the label you want cost details for
         * @param includeActuals include costs incurred during the delivery process that are variable?
         * @returns the cost breakdown as line items, total cost (sum of all line items), and the currency every amount is in.
         */
        this.getCostBreakdown = function (_a) {
            var merchant = _a.merchant, label = _a.label, _b = _a.includeActuals, includeActuals = _b === void 0 ? false : _b;
            var breakdown = [];
            var total = 0;
            var currency = types_1.Currency.USD;
            if (!merchant) {
                return { breakdown: breakdown, total: total, currency: currency };
            }
            var _c = merchant_1.MerchantController.getMerchantRateCard(merchant), rateCard = _c.rateCard, rateCardType = _c.rateCardType;
            currency = (rateCard === null || rateCard === void 0 ? void 0 : rateCard.currency) || currency;
            switch (rateCardType) {
                case types_1.RateCardType.rateCardV2:
                    breakdown.push.apply(breakdown, _this.getCostBreakdownRateCardV2(label, rateCard, includeActuals));
                    break;
                default:
                    breakdown.push.apply(breakdown, _this.getCostBreakdownRateCard(label, rateCard, includeActuals));
            }
            total = breakdown.reduce(function (sum, currBreakdown) { return sum + currBreakdown.amount; }, total);
            return { breakdown: breakdown, total: total, currency: currency };
        };
        var firebaseApp = (0, app_1.initializeApp)(config);
        this.db = (0, firestore_1.getFirestore)(firebaseApp);
        var firebaseFunctions = (0, functions_1.getFunctions)(firebaseApp);
        this.functions = {
            printPdfLabels: (0, functions_1.httpsCallable)(firebaseFunctions, "labels-printPdfLabels"),
            updateAndValidateDestinationAddress: (0, functions_1.httpsCallable)(firebaseFunctions, "httpsOnCallLabels-updateAndValidateDestinationAddress"),
            notifyOfDestinationChange: (0, functions_1.httpsCallable)(firebaseFunctions, "labels-notifyOfDestinationChange")
        };
    }
    return LabelController;
}());
exports["default"] = LabelController;
